import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard/Button'
import {LightBulbIcon} from '@primer/octicons-react'
import {Heading} from '@primer/react'

import styles from './GitCommandsBlock.module.css'

export interface GitCommandsBlockProps {
  repoName: string
  branch: string
  defaultUrl: string
}

export function GitCommandsBlock({repoName, branch, defaultUrl}: GitCommandsBlockProps) {
  const newRepoCommands = [
    `echo "# ${repoName}" >> README.md`,
    'git init',
    'git add README.md',
    'git commit -m "first commit"',
    `git branch -M ${branch}`,
    `git remote add origin ${defaultUrl}`,
    `git push -u origin ${branch}`,
  ].join('\n')

  const existingRepoCommands = [
    `git remote add origin ${defaultUrl}`,
    `git branch -M ${branch}`,
    `git push -u origin ${branch}`,
  ].join('\n')

  return (
    <>
      <CommandRow
        heading="…or create a new repository on the command line"
        commands={newRepoCommands}
        copyAriaLabel="Copy create commands to clipboard"
      />
      <CommandRow
        heading="…or push an existing repository from the command line"
        commands={existingRepoCommands}
        copyAriaLabel="Copy push commands to clipboard"
      />
    </>
  )
}

export function GitCommandsProTip() {
  return (
    <p className={styles.ProTip}>
      <LightBulbIcon className={styles.ProTipIcon} />
      <span>
        <strong>ProTip!</strong> Use the URL for this page when adding GitHub as a remote.
      </span>
    </p>
  )
}

function CommandRow({heading, commands, copyAriaLabel}: {heading: string; commands: string; copyAriaLabel: string}) {
  return (
    <div className={styles.CommandRow}>
      <Heading as="h3" variant="small" className={styles.CommandRowHeading}>
        {heading}
      </Heading>
      <div className={styles.CommandRowBodyWrapper}>
        <pre className={styles.CommandRowBody}>
          <code>{commands}</code>
        </pre>
        <CopyToClipboardButton
          className={styles.CommandRowCopyButton}
          size="small"
          textToCopy={commands}
          ariaLabel={copyAriaLabel}
        />
      </div>
    </div>
  )
}
